import { Icon } from "./Icon";
import { STORE_LINKS } from "../data/links";
import { useSiteTranslation } from "../i18n";
import goldSurface from "../../../pictures/store/store-gold-surface.jpg";
import "../styles/store.css";

function PlayLogo() {
  return (
    <svg className="mjm-store-play" viewBox="0 0 32 36" aria-hidden="true">
      <path fill="#c7a45d" d="M2 2.1 18.8 18 2 33.9Z" />
      <path fill="#ead7a7" d="m2 2.1 20.4 11.7-3.6 4.2Z" />
      <path fill="#aa8238" d="m2 33.9 20.4-11.7-3.6-4.2Z" />
      <path fill="#d8bd7f" d="m22.4 13.8 6.6 3.8c1.3.7 1.3 1.4 0 2.1l-6.6 3.8-3.6-5.4Z" />
    </svg>
  );
}

function StoreBadge({ href, label, store, logo }) {
  const { t } = useSiteTranslation();
  return (
    <a
      className={`mjm-store mjm-store--${store}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      style={{ "--store-surface": `url(${goldSurface})` }}
    >
      <span className="mjm-store-mark">{logo}</span>
      <span className="mjm-store-copy">
        <small>{t(store === "apple" ? "store.appleSmall" : "store.playSmall")}</small>
        <b>{t(store === "apple" ? "store.apple" : "store.play")}</b>
      </span>
    </a>
  );
}

/**
 * App Store and Google Play badges, shown together on every device. `showContext` adds the
 * "Available for iPhone, iPad, and Android." line underneath; it is off for now.
 */
export function StoreButtons({ id, className = "", showContext = false }) {
  const { t } = useSiteTranslation();
  return (
    <>
      <div className={`mjm-store-row ${className}`.trim()} id={id}>
        <StoreBadge
          store="apple"
          href={STORE_LINKS.apple}
          label={t("store.appleLabel")}
          logo={<Icon name="apple" className="mjm-store-apple" />}
        />
        <StoreBadge
          store="play"
          href={STORE_LINKS.play}
          label={t("store.playLabel")}
          logo={<PlayLogo />}
        />
      </div>
      {showContext && <p className="mjm-store-context">{t("store.context")}</p>}
    </>
  );
}
